var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "container", staticClass: "receipt-print-config" }, [
    _c("iframe", {
      staticClass: "receipt-print-iframe",
      attrs: { src: _vm.iframeSrc, frameborder: "0", title: "小票打印配置" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }